import React from 'react'
import Layout from '../../components/Layout'
import { useModal } from '../../hooks/modal'
import { useLoad } from '../../hooks/request'
import Card from '../../components/common/Card'
import Table from '../../components/common/Table'
import Button from '../../components/common/Button'
import AnimalTypeItem from '../../components/AnimalTypeItem'
import SettingsTabs from '../../components/settings/SettingsTabs'
import { ANIMAL_TYPE_LIST } from '../../urls'
import AnimalTypeCreate from '../../components/AnimalTypeCreate'

export default function AnimalType() {
    const animalTypes = useLoad({ url: ANIMAL_TYPE_LIST })

    const [showCreateModal, hideCreateModal] = useModal(
        <AnimalTypeCreate
            onSuccess={() => {
                hideCreateModal()
                animalTypes.request()
            }}
            onCancel={() => hideCreateModal()}
        />,
    )

    return (
        <Layout className="has-background-light">
            <SettingsTabs />

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <Card>
                    <div className="columns">
                        <div className="is-size-4 column">Ҳайвон турлари</div>

                        <div className="column is-narrow">
                            <Button onClick={showCreateModal} text="Қўшиш" icon="add-outline" className="is-pulled-right is-link is-outlined" />
                        </div>
                    </div>

                    <Table loading={animalTypes.loading} items={animalTypes.response ? animalTypes.response.results : []} renderItem={(item, index) => <AnimalTypeItem index={index} animalTypes={animalTypes} item={item} key={item.id} onDelete={animalTypes.request} onUpdate={animalTypes.request} status={animalTypes} />} />
                </Card>
                <br />
            </div>
        </Layout>
    )
}
